import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

function ActionBtn(props) {
  const mergedStyle = Object.assign(
    {
      color: 'white',
      width: '200px',
      height: '40px',
      borderRadius: '20px',
      backgroundColor:
        props.disabled || props.loading ? 'rgb(158, 158, 158)' : '#43c16a',
    },
    props.style
  );
  return (
    <Button
      onClick={() => {
        if (!props.disabled && props.onClick) {
          props.onClick();
        }
      }}
      disabled={props.disabled || props.loading}
      variant="contained"
      style={mergedStyle}>
      {props.loading && (
        <CircularProgress style={{ marginRight: '10px' }} size={20} />
      )}
      {props.label || 'Save'}
    </Button>
  );
}
ActionBtn.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default ActionBtn;
